












































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import DateUtils from '@/common/js/DateUtils'
import Enums from '@/lib/enums'
import { routers } from '@/router/router'
import moment from 'moment'



class PageOrderRequest extends PageRequest {

    orderNumber: string;
    constructor() {
        super();
    }
}

@Component({
    name: "orderOperateList",
})
export default class Orders extends AbpBase {
    pagerequest: PageOrderRequest = new PageOrderRequest();
    get list() {
        return this.$store.state.orderoperate.list;
    };
    get loading() {
        return this.$store.state.orderoperate.loading;
    }
    pageChange(page: number) {
        this.$store.commit('orderoperate/setCurrentPage', page);
        this.getpage();
    }
   
    pagesizeChange(pagesize: number) {
        this.$store.commit('orderoperate/setPageSize', pagesize);
        this.getpage();
    }   

    async getpage() {
      
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

        await this.$store.dispatch({
            type: 'orderoperate/getAll',
            data: this.pagerequest
        });
    }

    async searchPage() {
        this.$store.state.orderoperate.currentPage = 1;
        this.getpage();
    }

    get pageSize() {
        return this.$store.state.orderoperate.pageSize;
    }
    get totalCount() {
        return this.$store.state.orderoperate.totalCount;
    }
    get currentPage() {
        return this.$store.state.orderoperate.currentPage;
    }

    columns = [
        {
            title: '订单编号',
            key: 'orderNumber',
            width: 150,
         
        },
        {
            title: '用户编号',
            key: 'userCode',
            width: 90,
        },
        {
            title: '类别',
            width: 150,
            key: 'site',
            render: (h: any, params: any) => {
                return h('h2', { style: { color: "red", display: "inline-block" } }, Enums.OrderOperateType.filter(function (item) { return item.value == params.row.type })[0].name);

            }
        }, {
            title: '是否囤货',
            width: 90,
            key: 'isStock',
            render: (h: any, params: any) => {
                return h('span', params.row.isStock ? "是" : "否",
                )
            }
        }, {
            title: '创建时间',
            key: 'creationTime',
            width: 150,
            render: (h: any, params: any) => {
                return h('span', DateUtils.formatLongDate(new Date(params.row.creationTime)));
            }
        }]

    async created() {
        this.getpage();
    }
    async mounted() {
    }
}
